<template>
    <div class="container">
        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>
        <!-- Display Found User -->
        <div class="row mt-5">
            <div class="col-12">
                <div class="card bg-white">
                    <div class="card-body">
                        <dl v-if="theLookupUser" class="row">
                            <dt class="col-12">
                                <h3 class="nav-settings-head">
                                    <i class="fas fa-user"></i> {{theLookupUser.name | capitalize}}
                                </h3>
                                <p>
                                    <i class="fas fa-at"></i> 
                                    <router-link :to="{ name: 'lookup-handle', params: { handle: theLookupUser.userHandle } }">
                                        <span class="text-dark-green"> {{theLookupUser.userHandle}}</span>
                                    </router-link>
                                </p>
                                <p>
                                    <i class="fas fa-user-shield"></i> 
                                    <span v-if="theLookupUser.emailConfirmed" class="text-dark-green">
                                        aTrue Member
                                    </span>
                                    <span v-else class="text-muted">
                                        <span class="text-danger"> Not aTrue Member!</span> (User email must be verified to qualify!)
                                    </span>
                                </p>
                                <p>
                                    <i class="far fa-images"></i> 
                                    <span v-if="theLookupUser.itemsCount > 0" class="text-dark-green">
                                        Posted {{theLookupUser.itemsCount}} Item(s)
                                    </span>
                                    <span v-else class="text-muted">
                                        <span class="text-danger"> Posted No Item!</span> (User must post an item to qualify!)
                                    </span>
                                </p>
                            </dt>
                            <dt class="col-lg-10 col-md-9 col-sm-8 col-12">
                                <p v-if="userRoles">
                                    <i class="fas fa-scroll"></i> I'm a: {{userRoles}}
                                </p>
                            </dt>
                            <dd class="col-lg-2 col-md-3 col-sm-4 col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <button @click="addMarketerFxn" class="btn btn-dark-green btn-sm form-control">
                                            <i class="fas fa-plus"></i> Make Referrer
                                        </button>
                                    </div>
                                </div>
                            </dd>
                        </dl>
                        <dl v-else class="row">
                            <div class="col-12 text-center">
                                <i class="fas fa-spinner fa-pulse fa-2x text-dark-green my-3"></i>
                                <p>Fetching result, please wait...</p>
                            </div>
                        </dl>
                    </div>
                </div>
                <p class="text-center mt-3">
                    <router-link :to="{ name: 'portal' }" class="btn btn-light-green">
                        <i class="fas fa-search"></i> Return to Search
                    </router-link>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { capitalizeWord } from '@/store/dry'
import LayoutUser from '@/layouts/User.vue'
export default {
    name: "PortalLookup",
    data() {
        return {
            color: 'danger',
            msg: ''
        }
    },
    methods: {
        ...mapActions(['portalLookupUser', 'addMarketer']),
        addMarketerFxn() {
            this.resetAll()
            if(!this.theLookupUser){ this.msg = "Unable to proceed! Click 'Return to Search' to find a user!"; return }
            if(!this.theLookupUser.emailConfirmed){ 
                this.msg = `${capitalizeWord(this.theLookupUser.name)} email must be verified to qualify for this role!`; 
                return 
            }
            if(!this.theLookupUser.itemsCount > 0){ 
                this.msg = `${capitalizeWord(this.theLookupUser.name)} must post at least one item to qualify for this role!`;
                return 
            }
            let marketerObj = {
                userId: this.theLookupUser._id,
                stateRepId: this.user._id,
            }
            this.addMarketer(marketerObj)
            .then((data) => {
                if(!data.error) {
                    this.color = 'success'
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        },
        runPortalLookupUser(theUserId) {
            let userObj = {
                userId: theUserId
            }
            this.portalLookupUser(userObj)
            .then((data) => {
                this.msg = data.msg
                if(!data.error){
                    this.color = 'success'
                }
                this.resetAll()
            })
            .catch((e) => {
                this.msg = 'Unable to reach portal at this time! Try again later'
            })
        },
        resetAll() {
            this.color = 'danger'
            this.msg = ''
        }
    },
    computed: {
        ...mapGetters(['user', 'portalLookup']),
        theLookupUser() {
            if(this.portalLookup && this.portalLookup !== null) {
                return this.portalLookup
            }
            return false
        },
        userRoles() {
            if(this.theLookupUser){
                return this.theLookupUser.roles.join(", ")
            }
            return false
        },
    },
    created() {
        this.resetAll()
        this.runPortalLookupUser(this.$route.params.userId)
        this.$emit('update:layout', LayoutUser);
    }
}
</script>